<template>
  <a-modal
    v-model="show"
    :width="960"
    title="热门问题"
  >
    <div>
      <div class="fs-b fs-16">
        1、快递公司运费标准
      </div>
      <div style="text-indent: 2em;">
        每一家快递公司的收费标准不一样，详细请查阅<a @click="$router.push('/main/send/waybill-query')">《快递公司运费查询参照表》</a>
      </div>
      <div class="fs-b fs-16 mt-8">
        2、快递员未能及时上门取件？
      </div>
      <div style="text-indent: 2em;">
        下单后请留意手机短信及消息提醒，通常快递员会在1-4个小时区间上门，如快递员未能在预约时段内上门，可通过：订单监控 > 待取件 > 催单功能，或联系在线QQ群
      </div>
      <div class="fs-b fs-16 mt-8">
        3、能否寄个人的包裹快递？
      </div>
      <div style="text-indent: 2em;">
        快递鸟企业寄件，支持对公寄件、因私寄件，对公寄件统一使用公司预付款账户（需由管理员充值后使用）并有统一的寄件记录，因私寄件只支持个人与快递员线下支付运费，所有寄件费用、记录与公司无关。
      </div>
      <div class="fs-b fs-16 mt-8">
        4、下单后的取件码是什么？
      </div>
      <div style="text-indent: 2em;">
        取件码是确认订单与快递员的对应码，每一个订单都有一个取件码，在快递员没有上门前请不要提供，避免快递员虚假揽件。
      </div>
      <div class="fs-b fs-16 mt-8">
        5、包裹破损/丢件如何快速处理？
      </div>
      <div style="text-indent: 2em;">
        请联系快递公司，或者通过“所有订单 > 物流投诉”在线工单进行处理，由快递鸟企业寄件客服在线处理和实时反馈。
      </div>
    </div>

    <div slot="footer">
      <a-button type="primary" @click="show = false">好的，我知道了</a-button>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    viz: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: this.viz
    }
  },
  watch: {
    show(n) {
      this.$emit('update:viz', n)
    },
    viz(n) {
      this.show = n
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
